module.exports = __webpack_public_path__ + "static/img/006.8484d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/006.png
// module id = L8U9
// module chunks = 0